import { render, staticRenderFns } from "./longtextanswer.vue?vue&type=template&id=b828d0f6&scoped=true&"
import script from "./longtextanswer.vue?vue&type=script&lang=js&"
export * from "./longtextanswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b828d0f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\english\\new-evaluation\\src\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b828d0f6')) {
      api.createRecord('b828d0f6', component.options)
    } else {
      api.reload('b828d0f6', component.options)
    }
    module.hot.accept("./longtextanswer.vue?vue&type=template&id=b828d0f6&scoped=true&", function () {
      api.rerender('b828d0f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/longtextanswer/longtextanswer.vue"
export default component.exports